import React, { Component } from 'react';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import moment from 'moment';
import memoize from 'memoize-one';
import InfiniteScroll from 'react-infinite-scroller';
import PropTypes from 'prop-types';
import DashboardFilter from '../DashboardFilter/DashboardFilter';
import './UserBalanceHistory.scss';
import { formatRequestDate, formatLogDate } from '../../../utils/helpers';
import mask from '../CurrencyField/assets/mask';
import { TEXT_FIELD_STATUS, LOADING } from '../../../utils/constants';
//

const arrowIcon = require('./assets/arrow.svg');

const appFilterName = 'app-filter';
const campaignFilterName = 'campaign-filter';

class UserBalanceHistory extends Component {
  static propTypes = {
    getBalanceHistory: PropTypes.func.isRequired,
    hasMoreBalanceHistory: PropTypes.bool.isRequired,
    balanceHistory: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    page: PropTypes.number.isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaignsStatus: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    refillBalanceStatus: PropTypes.string.isRequired,
  };
  state = {
    datePicker: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
    focusedDatePickerInput: null,
    filters: {
      [appFilterName]: {
        value: '',
        status: '',
      },
      [campaignFilterName]: {
        value: '',
        status: '',
      },
    },
  };

  componentWillMount() {
    this.getBalanceHistoryWithParams();
  }

  componentDidUpdate(prevProps) {
    const { refillBalanceStatus } = this.props;
    if (
      refillBalanceStatus !== prevProps.refillBalanceStatus &&
      refillBalanceStatus !== LOADING
    ) {
      // doing this, coz amount saves async at back-end but
      // send success anyway and need to wait some time, to update events
      setTimeout(() => {
        this.getBalanceHistoryWithParams();
      }, 1200);
    }
  }
  getBalanceHistoryWithParams = (notFirst) => {
    const params = {};
    const { getBalanceHistory, page, id } = this.props;
    const dates = { ...this.state.datePicker };
    const filters = { ...this.state.filters };
    params.from = formatRequestDate(dates.startDate);
    params.to = formatRequestDate(dates.endDate);
    const appId = filters[appFilterName].value;
    const campaignId = filters[campaignFilterName].value;
    if (notFirst) {
      params.page = page + 1;
    } else {
      params.page = 0;
    }
    if (appId) {
      params.appId = appId;
    }
    if (campaignId) {
      params.campaignId = campaignId;
    }
    if (id) {
      params.userId = id;
    }

    getBalanceHistory(params);
  };

  appFilterChangeHandler = ({ name, value }) => {
    const filters = {
      ...this.state.filters,
    };
    if (value) {
      filters[name].status = TEXT_FIELD_STATUS.VALID;
    } else {
      filters[name].status = TEXT_FIELD_STATUS.INITIAL;
    }
    filters[name].value = value.value;
    filters[campaignFilterName].value = '';
    this.setState(
      () => ({ filters }),
      () => {
        if (filters[name].value) {
          this.props.getAppCampaigns({ appId: filters[name].value });
        }

        this.getBalanceHistoryWithParams();
      },
    );
  };

  campaignFilterChangeHandler = ({ name, value }) => {
    const filters = {
      ...this.state.filters,
    };
    if (value) {
      filters[name].status = TEXT_FIELD_STATUS.VALID;
    } else {
      filters[name].status = TEXT_FIELD_STATUS.INITIAL;
    }
    filters[name].value = value.value;
    this.setState(
      () => ({ filters }),
      () => {
        this.getBalanceHistoryWithParams();
      },
    );
  };

  transformCampaignsForFilter = memoize((campaigns) => {
    const transformedCampaigns = campaigns.map(campaign => ({
      label: campaign.name,
      value: campaign.id,
    }));
    const firstElement = [
      {
        label: 'All',
        value: '',
      },
    ];
    return [...firstElement, ...transformedCampaigns];
  });

  extractApps = memoize(apps => [
    ...[{ value: '', label: 'All' }],
    ...apps.map(app => ({ value: app.id, label: app.name })),
  ]);

  datesChangeHandler = ({ startDate, endDate }) => {
    const datePicker = {
      ...this.state.datePicker,
    };

    datePicker.startDate = startDate;
    datePicker.endDate = endDate;
    const isValidEnd = moment(datePicker.endDate).isValid();
    this.setState(
      () => ({
        datePicker,
      }),
      () => {
        if (isValidEnd) {
          this.getBalanceHistoryWithParams();
        }
      },
    );
  };

  datesFocusHandler = (focusedDatePickerInput) => {
    this.setState(
      () => ({ focusedDatePickerInput }),
      () => {
        this.getBalanceHistoryWithParams();
      },
    );
  };
  render() {
    const { datePicker, focusedDatePickerInput, filters } = this.state;
    const {
      hasMoreBalanceHistory,
      balanceHistory,
      apps,
      currentAppCampaigns,
      getAppCampaignsStatus,
    } = this.props;
    const appFilter = filters[appFilterName];
    const campaignFilter = filters[campaignFilterName];
    const extractedApps = this.extractApps(apps);
    const extractedCampaigns = this.transformCampaignsForFilter(currentAppCampaigns);

    return (
      <div className="user-balance-history-wrapper">
        <div className="main-label-no-transform">
          <span>History</span>
        </div>
        <div className="history-tabel-control">
          <div className="date-picker-wrapper">
            <DateRangePicker
              startDate={datePicker.startDate}
              startDateId="id-start-date"
              endDate={datePicker.endDate}
              endDateId="id-end-date"
              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
              displayFormat="DD MMMM"
              readOnly
              customArrowIcon="&mdash;"
              focusedInput={focusedDatePickerInput}
              onDatesChange={this.datesChangeHandler}
              onFocusChange={this.datesFocusHandler}
              customInputIcon={<img src={arrowIcon} alt="arrow" />}
            />
          </div>
          <DashboardFilter
            name={appFilterName}
            status={appFilter.status}
            value={appFilter.value}
            values={extractedApps}
            changeHandler={this.appFilterChangeHandler}
            label="By App"
          />
          {appFilter.value && (
            <DashboardFilter
              name={campaignFilterName}
              status={campaignFilter.status}
              value={campaignFilter.value}
              values={extractedCampaigns}
              disabled={getAppCampaignsStatus === LOADING}
              changeHandler={this.campaignFilterChangeHandler}
              label="By Campaign"
            />
          )}
        </div>
        <div className="user-balance-history">
          <div className="ct-table">
            <div className="ct-thead">
              <div className="ct-tr">
                <div className="ct-th">Date</div>
                <div className="ct-th">Event Type</div>
                <div className="ct-th">Amount</div>
                <div className="ct-th">Text</div>
              </div>
            </div>

            <div className="ct-tbody">
              {balanceHistory.length ? (
                <InfiniteScroll
                  pageStart={0}
                  loadMore={this.getBalanceHistoryWithParams}
                  hasMore={hasMoreBalanceHistory}
                  useWindow={false}
                  isReset
                  element="div"
                  loader={
                    <div className="loader" key={0}>
                      Loading ...
                    </div>
                  }
                >
                  {balanceHistory.map(balanceHistoryItem => (
                    <div className="ct-tr">
                      <div className="ct-td">
                        <span>{formatLogDate(balanceHistoryItem.date)} </span>
                      </div>
                      <div className="ct-td">
                        <span> {balanceHistoryItem.type}</span>
                      </div>
                      <div className="ct-td">
                        <span>
                          {mask(
                            balanceHistoryItem.amount,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true,
                          )}{' '}
                          $
                        </span>
                      </div>
                      <div className="ct-td">
                        <span> {balanceHistoryItem.message} </span>
                      </div>
                    </div>
                  ))}
                </InfiniteScroll>
              ) : (
                <div className="placeholder-wrapper">
                  <span>There is no data yet for this period...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserBalanceHistory;



// WEBPACK FOOTER //
// ./src/components/_molecules/UserBalanceHistory/UserBalanceHistory.js